const PageTemplateType = require('constants/PageTemplateType');

const SpaTemplatesInfo = [{
    template: PageTemplateType.ProductPage,
    pageName: 'product',
    killSwitchName: 'spaEnabledProduct',
    url: '/product/'
}, {
    template: PageTemplateType.RwdNthCategory,
    pageName: 'nthCategory',
    killSwitchName: 'spaEnabledCategory',
    url: '/shop/'
}, {
    template: PageTemplateType.RwdBrandNthCategory,
    pageName: 'nthBrand',
    killSwitchName: 'spaEnabledBrand',
    url: '/brand/'
}, {
    template: PageTemplateType.RwdSearch,
    pageName: 'search',
    killSwitchName: 'spaEnabledSearch',
    url: '/search'
}, {
    template: PageTemplateType.RwdSearch,
    pageName: 'sale',
    killSwitchName: 'spaEnabledSearch',
    url: '/sale'
}, {
    template: PageTemplateType.Basket,
    pageName: 'basket',
    pagePropName: 'basket',
    killSwitchName: 'spaEnabledBasket',
    url: '/basket'
}, {
    template: PageTemplateType.RwdContentStore,
    pageName: 'contentStoreData',
    killSwitchName: 'spaEnabledBeautyOffer',
    url: '/beauty/beauty-offers'
}, {
    template: PageTemplateType.BuyPage,
    pageName: 'buyPage',
    killSwitchName: 'spaEnabledBuyPage',
    url: '/buy/'
}, {
    template: PageTemplateType.RwdHomepage,
    pageName: 'home',
    killSwitchName: 'spaEnabledHomePage',
    url: '/'
}];


module.exports = { SpaTemplatesInfo };
